// extracted by mini-css-extract-plugin
export var label = "_hx-2";
export var slideContainer = "_hx-0";
export var slider = "_hx-1";